import AppDispatcher from '../../core/AppDispatcher'
import AccountTitleDetailEvent from '../../event/AccountTitleDetailEvent'

const onEdit = event => {
  AppDispatcher.dispatchWithType(AccountTitleDetailEvent.onEdit, {
    name: event.target.name,
    value: event.target.value
  })

  return true
}

export default onEdit
